import { encodeParam } from "utilities/misc";
import { get } from "utilities/network";

export const httpDashboardStats = () => {
  return get(`support/stats/dashboard`);
};

export const httpBalances = (type: string) => {
  return get(`support/balances/${encodeParam(type)}`);
};

export const httpGetRate = () => {
  return get(`support/transactions/rate`);
};

export const httpAnalytics = (type: string, which: string, date: string) => {
  return get(
    `support/analytics/${encodeParam(type)}?which=${encodeParam(which)}&date=${encodeParam(date)}`,
  );
};

export const httpTransactionAnalytics = (type: string, date: Date | string) => {
  return get(
    `support/analytics/transactionAnalytics?date=${encodeParam(date)}&type=${encodeParam(type)}`,
  );
};
